// // ** Redux Imports
// import { createStore, applyMiddleware } from 'redux';
// import rootReducer from './reducers'; // Ajusta la ruta de tu archivo de reducers

// const store = createStore(rootReducer, applyMiddleware(thunk));

// export default store;

import thunk from "redux-thunk";
import rootReducer from "./rootReducer";
import { configureStore } from "@reduxjs/toolkit";

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat(thunk),
});

export { store };
